$(window).load(function(){
	if($('.input-text, textarea').val() == true){
		 if(!$(this).hasClass('has-value')){
			$(this).addClass('has-value');
		}
	}

	$('.input-text, textarea').focusin(function(){
		$(this).addClass('has-value');
	}).focusout( function(){
		if(!$(this).val()){
			$(this).removeClass('has-value');
		}
	});

	$('.gfield_select').parent().addClass('select-wrapper').append('<div class="caret"></div>');

	$('#camp-map').height($('.mapplic-map').height());
});
$(document).ready(function() {
	setInterval(function() {
		var $days = +($('#days').text()),
			$hours = +($('#hours').text()),
			$mins = +($('#minutes').text());

		if($mins == 0) {
			if($hours == 0) {
				$days--;
				$hours = 23;
			} else {
				$hours--;
			}
			$mins = 59;
		} else {
			$mins--;
		}

		$('#days').text($days);
		$('#hours').text($hours < 10 ? '0' + $hours : $hours);
		$('#minutes').text($mins < 10 ? '0' + $mins : $mins);
	}, 60000);

	$('#camp-map').mapplic({
		source: '/wp-content/themes/deerhorn/map/camp.json',
		height: 1200,
		mapfill: true,
		clearbutton: false,
		minimap: false,
		sidebar: false,
		hovertip: false,
		//developer: true,
		mousewheel: false,
		zoomoutclose: false,
		maxscale: 2
	});


	/******** Photo Gallery Template Functions ********/
	function imageHoverWidth() {
		var imageHolder = $('.photo-grid .image-holder');

		imageHolder.each(function() {
			var	image = $(this).find('img'),
				hover = $(this).find('.hover');

			$(this).imagesLoaded( function() {
				hover.outerWidth(image.width());
				hover.css('top', image.height()-hover.outerHeight());
			})
		});
	}
	function imageHoverAppear() {
		var image = $('.photo-grid .image-holder img');

		if($(window).width() > 768) {
			image.each(function() {
				$(this).hover(
					function() {
						$(this).siblings('.hover').css('visibility','visible');
					},
					function() {
						$(this).siblings('.hover').css('visibility','hidden');
					}
				);
			});
		}
	}
	function gallerySlider() {
		var slickElem = $('#imageModal .slider'),
			paging = $('#imageModal .paging'),
			photoCredit = $('#imageModal .photo-credit');

		slickElem.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
			var i = (currentSlide ? currentSlide : 0) + 1,
				credit = $(slick.$slides[currentSlide]).data('credit');

			paging.text(i + ' of ' + slick.slideCount);

			if(credit) {
				photoCredit.removeClass('no-credit');
				photoCredit.find("span").text(credit);
			} else {
				photoCredit.addClass('no-credit');
			}
		});

		slickElem.slick({
			arrows: true,
			dots: false,
			infinite: true,
			mobileFirst: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '40px',
			lazyLoad: 'ondemand',
			prevArrow: '<img class="prev-slide" aria-label="Previous" src="/assets/img/prev-arrow.svg" />',
			nextArrow: '<img class="next-slide" aria-label="Next" src="/assets/img/next-arrow.svg" />',
			responsive: [{
				breakpoint: 768,
				settings: {
					centerPadding: '13%',
				}
			}],
		});
	}
	function galleryModal() {
		var image = $('.photo-grid .image-holder img'),
			closeBtn = $('#imageModal .close-btn'),
			modal = $('#imageModal'),
			slickElem = $('#imageModal .slider');

		image.on('click', function() {
			var slideNum = $(this).data('slide');

			modal.show();
			slickElem.slick('slickGoTo', slideNum, true);
		});

		closeBtn.on('click', function() {
			modal.hide();
		});
	}
	function loadImages(postID) {
		var offset = $('.photo-grid .row .image-holder:last-child img').data('slide');

		var data = {
			offset: offset+1,
			postID: postID,
			action: "load_more_images"
		};

		$.post(ajax_global.url, data, function(response) {
			var more = response['more'],
				slickElem = $('#imageModal .slider');

			$(".photo-grid .row").append(response['photoGrid']);
			slickElem.slick('slickAdd', response['slider']);
			if(!more) {
				$('#load-more-link').hide();
			}

			$(document.body).trigger('images-loaded');
		});
	}

	if($(".page-template-template-photo-gallery").length) {
		imageHoverWidth();
		imageHoverAppear();
		gallerySlider();
		galleryModal();

		$(window).resize(function() {
			imageHoverWidth();
			imageHoverAppear();
		});

		$(document.body).on('images-loaded', function () {
			imageHoverAppear();
			galleryModal();
			$('.photo-grid').imagesLoaded(function() {
				imageHoverWidth();
			});
		});
	}

	$(document).on('click', '#load-more-link',function(e) {
		e.preventDefault();
		loadImages($(this).data('post-id'));
	})

});
